// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {Form} from '@supermove/hooks';
import {OrganizationModel} from '@supermove/models';

// App
import DropdownInput from '@shared/design/components/DropdownInput';
import FieldInput from '@shared/design/components/Field/FieldInput';

const CompanyAccountSelect = ({
  index,
  organization,
  form,
  name,
  isRequired,
}: {
  index: number;
  organization: OrganizationModel;
  form: Form;
  name: string;
  isRequired: boolean;
}) => {
  const companyAccountOptions = organization.activeAccountGrants.map((accountGrant) => ({
    value: accountGrant.id,
    label: accountGrant.identifier,
  }));

  return (
    <FieldInput
      {...form}
      index={index}
      label={'Company Account'}
      name={name}
      component={DropdownInput}
      isResponsive
      isRequired={isRequired}
      input={{
        options: companyAccountOptions,
        setFieldValue: form.setFieldValue,
        placeholder: `Select company account`,
        isPortaled: true,
        style: {flex: 1},
      }}
    />
  );
};

CompanyAccountSelect.fragment = gql`
  fragment CompanyAccountSelect on Organization {
    id
    activeAccountGrants {
      id
      identifier
    }
  }
`;

export default CompanyAccountSelect;
